import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=074aace8&scoped=true&"
import script from "./NavigationBar.vue?vue&type=script&lang=js&"
export * from "./NavigationBar.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBar.vue?vue&type=style&index=0&id=074aace8&prod&lang=scss&scoped=true&"
import style1 from "./NavigationBar.vue?vue&type=style&index=1&id=074aace8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074aace8",
  null
  
)

/* custom blocks */
import block0 from "./NavigationBar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports